/**
 * Generated from PostcardMunich1Layout.fla
 */
export function PostcardMunich1Layout(this: IPostcardMunich1Layout) {
	const main = this.main;
	PostcardMunich1Layout_main.call(this.main);
	main.x = 1024;
	main.y = 768;
	if (main.onLayout) main.onLayout();
	return this;
}
export function PostcardMunich1Layout_main(this: IPostcardMunich1Layout_main) {
	const postcard = this.postcard;
	PostcardMunich1Layout_postcard.call(this.postcard);
	postcard.x = 0;
	postcard.y = 4.7;
	if (postcard.scale) postcard.scale.x = 0.633;
	if (postcard.scale) postcard.scale.y = 0.633;
	if (postcard.onLayout) postcard.onLayout();
	return this;
}
function PostcardMunich1Layout_postcard(this: IPostcardMunich1Layout_postcard) {
	const cardTransform = this.cardTransform;
	if (!cardTransform[0] && cardTransform.elementFactory) {
		cardTransform[0] = cardTransform.elementFactory(0,undefined);
	}
	if (cardTransform[0]) {
		PostcardMunich1Layout_cardTransform1.call(cardTransform[0] as IPostcardMunich1Layout_cardTransform1);
		cardTransform[0].x = -645.35;
		cardTransform[0].y = 335.4;
		cardTransform[0].width = 442.09;
		cardTransform[0].height = 554.15;
		if (cardTransform[0].onLayout) cardTransform[0].onLayout();
	}
	if (!cardTransform[1] && cardTransform.elementFactory) {
		cardTransform[1] = cardTransform.elementFactory(1,undefined);
	}
	if (cardTransform[1]) {
		PostcardMunich1Layout_cardTransform2.call(cardTransform[1] as IPostcardMunich1Layout_cardTransform2);
		cardTransform[1].x = 564.05;
		cardTransform[1].y = 264.65;
		cardTransform[1].width = 679.22;
		cardTransform[1].height = 851.38;
		if (cardTransform[1].onLayout) cardTransform[1].onLayout();
	}
	if (!cardTransform[2] && cardTransform.elementFactory) {
		cardTransform[2] = cardTransform.elementFactory(2,undefined);
	}
	if (cardTransform[2]) {
		PostcardMunich1Layout_cardTransform3.call(cardTransform[2] as IPostcardMunich1Layout_cardTransform3);
		cardTransform[2].x = -516.5;
		cardTransform[2].y = -178.25;
		cardTransform[2].width = 744.87;
		cardTransform[2].height = 933.68;
		if (cardTransform[2].onLayout) cardTransform[2].onLayout();
	}
	if (!cardTransform[3] && cardTransform.elementFactory) {
		cardTransform[3] = cardTransform.elementFactory(3,undefined);
	}
	if (cardTransform[3]) {
		PostcardMunich1Layout_cardTransform4.call(cardTransform[3] as IPostcardMunich1Layout_cardTransform4);
		cardTransform[3].x = 71.25;
		cardTransform[3].y = 234.4;
		cardTransform[3].width = 523.69;
		cardTransform[3].height = 656.43;
		if (cardTransform[3].onLayout) cardTransform[3].onLayout();
	}
	if (!cardTransform[4] && cardTransform.elementFactory) {
		cardTransform[4] = cardTransform.elementFactory(4,undefined);
	}
	if (cardTransform[4]) {
		PostcardMunich1Layout_cardTransform5.call(cardTransform[4] as IPostcardMunich1Layout_cardTransform5);
		cardTransform[4].x = -170.7;
		cardTransform[4].y = -453.6;
		cardTransform[4].width = 385.24;
		cardTransform[4].height = 482.89;
		if (cardTransform[4].onLayout) cardTransform[4].onLayout();
	}
	if (!cardTransform[5] && cardTransform.elementFactory) {
		cardTransform[5] = cardTransform.elementFactory(5,undefined);
	}
	if (cardTransform[5]) {
		PostcardMunich1Layout_cardTransform6.call(cardTransform[5] as IPostcardMunich1Layout_cardTransform6);
		cardTransform[5].x = 236.9;
		cardTransform[5].y = -171.9;
		cardTransform[5].width = 777.76;
		cardTransform[5].height = 974.90;
		if (cardTransform[5].onLayout) cardTransform[5].onLayout();
	}
	if (!cardTransform[6] && cardTransform.elementFactory) {
		cardTransform[6] = cardTransform.elementFactory(6,undefined);
	}
	if (cardTransform[6]) {
		PostcardMunich1Layout_cardTransform7.call(cardTransform[6] as IPostcardMunich1Layout_cardTransform7);
		cardTransform[6].x = -298.75;
		cardTransform[6].y = 149.4;
		cardTransform[6].width = 478.02;
		cardTransform[6].height = 599.18;
		if (cardTransform[6].onLayout) cardTransform[6].onLayout();
	}
	if (!cardTransform[7] && cardTransform.elementFactory) {
		cardTransform[7] = cardTransform.elementFactory(7,undefined);
	}
	if (cardTransform[7]) {
		PostcardMunich1Layout_cardTransform8.call(cardTransform[7] as IPostcardMunich1Layout_cardTransform8);
		cardTransform[7].x = 528.9;
		cardTransform[7].y = 470.6;
		cardTransform[7].width = 296.30;
		cardTransform[7].height = 371.40;
		if (cardTransform[7].onLayout) cardTransform[7].onLayout();
	}
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		PostcardMunich1Layout_pieces3.call(items[0] as IPostcardMunich1Layout_pieces3);
		items[0].x = -541.7;
		items[0].y = -163.5;
		items[0].width = 496.00;
		items[0].height = 838.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,undefined);
	}
	if (items[1]) {
		PostcardMunich1Layout_outlines3.call(items[1] as IPostcardMunich1Layout_outlines3);
		items[1].x = -540.45;
		items[1].y = -155.35;
		items[1].width = 495.00;
		items[1].height = 855.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,undefined);
	}
	if (items[2]) {
		PostcardMunich1Layout_pieces6.call(items[2] as IPostcardMunich1Layout_pieces6);
		items[2].x = 241.5;
		items[2].y = -70;
		items[2].width = 1039.00;
		items[2].height = 814.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,undefined);
	}
	if (items[3]) {
		PostcardMunich1Layout_outlines6.call(items[3] as IPostcardMunich1Layout_outlines6);
		items[3].x = 346.45;
		items[3].y = -211.3;
		items[3].width = 916.00;
		items[3].height = 740.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,undefined);
	}
	if (items[4]) {
		PostcardMunich1Layout_pieces5.call(items[4] as IPostcardMunich1Layout_pieces5);
		items[4].x = -158;
		items[4].y = -469.6;
		items[4].width = 296.00;
		items[4].height = 760.00;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,undefined);
	}
	if (items[5]) {
		PostcardMunich1Layout_outlines5.call(items[5] as IPostcardMunich1Layout_outlines5);
		items[5].x = -159.95;
		items[5].y = -466.35;
		items[5].width = 274.00;
		items[5].height = 184.00;
		if (items[5].onLayout) items[5].onLayout();
	}
	if (!items[6] && items.elementFactory) {
		items[6] = items.elementFactory(6,undefined);
	}
	if (items[6]) {
		PostcardMunich1Layout_pieces7.call(items[6] as IPostcardMunich1Layout_pieces7);
		items[6].x = -310.7;
		items[6].y = 154.35;
		items[6].width = 355.00;
		items[6].height = 319.00;
		if (items[6].onLayout) items[6].onLayout();
	}
	if (!items[7] && items.elementFactory) {
		items[7] = items.elementFactory(7,undefined);
	}
	if (items[7]) {
		PostcardMunich1Layout_outlines7.call(items[7] as IPostcardMunich1Layout_outlines7);
		items[7].x = -300.55;
		items[7].y = 149.1;
		items[7].width = 336.00;
		items[7].height = 302.00;
		if (items[7].onLayout) items[7].onLayout();
	}
	if (!items[8] && items.elementFactory) {
		items[8] = items.elementFactory(8,{"dependsOn":0,"outlineGlow":true});
	}
	if (items[8]) {
		PostcardMunich1Layout_pieces1.call(items[8] as IPostcardMunich1Layout_pieces1);
		(items[8] as IPostcardMunich1Layout_pieces1).dependsOn = 0;
		(items[8] as IPostcardMunich1Layout_pieces1).outlineGlow = true;
		items[8].x = -644.05;
		items[8].y = 345.55;
		items[8].width = 306.00;
		items[8].height = 370.00;
		if (items[8].onLayout) items[8].onLayout();
	}
	if (!items[9] && items.elementFactory) {
		items[9] = items.elementFactory(9,undefined);
	}
	if (items[9]) {
		PostcardMunich1Layout_outlines1.call(items[9] as IPostcardMunich1Layout_outlines1);
		items[9].x = -643.05;
		items[9].y = 340.1;
		items[9].width = 308.00;
		items[9].height = 361.00;
		if (items[9].onLayout) items[9].onLayout();
	}
	if (!items[10] && items.elementFactory) {
		items[10] = items.elementFactory(10,{"dependsOn":0,"outlineGlow":true});
	}
	if (items[10]) {
		PostcardMunich1Layout_pieces4.call(items[10] as IPostcardMunich1Layout_pieces4);
		(items[10] as IPostcardMunich1Layout_pieces4).dependsOn = 0;
		(items[10] as IPostcardMunich1Layout_pieces4).outlineGlow = true;
		items[10].x = 77.55;
		items[10].y = 232.3;
		items[10].width = 440.00;
		items[10].height = 270.00;
		if (items[10].onLayout) items[10].onLayout();
	}
	if (!items[11] && items.elementFactory) {
		items[11] = items.elementFactory(11,undefined);
	}
	if (items[11]) {
		PostcardMunich1Layout_outlines4.call(items[11] as IPostcardMunich1Layout_outlines4);
		items[11].x = 66.65;
		items[11].y = 223.9;
		items[11].width = 417.00;
		items[11].height = 249.00;
		if (items[11].onLayout) items[11].onLayout();
	}
	if (!items[12] && items.elementFactory) {
		items[12] = items.elementFactory(12,{"dependsOn":0,"outlineGlow":true});
	}
	if (items[12]) {
		PostcardMunich1Layout_pieces2.call(items[12] as IPostcardMunich1Layout_pieces2);
		(items[12] as IPostcardMunich1Layout_pieces2).dependsOn = 0;
		(items[12] as IPostcardMunich1Layout_pieces2).outlineGlow = true;
		items[12].x = 579.6;
		items[12].y = 282.75;
		items[12].width = 513.98;
		items[12].height = 495.98;
		if (items[12].onLayout) items[12].onLayout();
	}
	if (!items[13] && items.elementFactory) {
		items[13] = items.elementFactory(13,undefined);
	}
	if (items[13]) {
		PostcardMunich1Layout_outlines2.call(items[13] as IPostcardMunich1Layout_outlines2);
		items[13].x = 580.25;
		items[13].y = 281.05;
		items[13].width = 513.00;
		items[13].height = 491.00;
		if (items[13].onLayout) items[13].onLayout();
	}
	if (!items[14] && items.elementFactory) {
		items[14] = items.elementFactory(14,{"dependsOn":0,"outlineGlow":true});
	}
	if (items[14]) {
		PostcardMunich1Layout_pieces8.call(items[14] as IPostcardMunich1Layout_pieces8);
		(items[14] as IPostcardMunich1Layout_pieces8).dependsOn = 0;
		(items[14] as IPostcardMunich1Layout_pieces8).outlineGlow = true;
		items[14].x = 515.95;
		items[14].y = 483.35;
		items[14].width = 201.00;
		items[14].height = 150.00;
		if (items[14].onLayout) items[14].onLayout();
	}
	if (!items[15] && items.elementFactory) {
		items[15] = items.elementFactory(15,undefined);
	}
	if (items[15]) {
		PostcardMunich1Layout_outlines8.call(items[15] as IPostcardMunich1Layout_outlines8);
		items[15].x = 527.25;
		items[15].y = 477.95;
		items[15].width = 176.00;
		items[15].height = 140.00;
		if (items[15].onLayout) items[15].onLayout();
	}
	const background = this.background;
	PostcardMunich1Layout_background.call(this.background);
	background.x = 0;
	background.y = 0;
	background.width = 1790.00;
	background.height = 1325.00;
	if (background.onLayout) background.onLayout();
	const postcardOverlay = this.postcardOverlay;
	PostcardMunich1Layout_postcardOverlay.call(this.postcardOverlay);
	postcardOverlay.x = 0;
	postcardOverlay.y = 0;
	postcardOverlay.width = 1784.00;
	postcardOverlay.height = 1318.00;
	if (postcardOverlay.onLayout) postcardOverlay.onLayout();
	const postcardMask = this.postcardMask;
	postcardMask.push(11.60,-642.40,878.60,-641.10,869.70,11.90,875.65,626.30,29.70,629.25,-492.65,638.15,-880.20,652.65,-875.55,-47.50,-881.50,-655.95);
	return this;
}
function PostcardMunich1Layout_background(this: IPostcardMunich1Layout_background) {
	if (this.setLayoutTexture) this.setLayoutTexture("postcard-munich-1.png", 0.500, 0.500);
	return this;
}
function PostcardMunich1Layout_cardTransform7(this: IPostcardMunich1Layout_cardTransform7) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-munich-1-7.png", 0.500, 0.500);
	return this;
}
function PostcardMunich1Layout_cardTransform6(this: IPostcardMunich1Layout_cardTransform6) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-munich-1-6.png", 0.500, 0.500);
	return this;
}
function PostcardMunich1Layout_cardTransform5(this: IPostcardMunich1Layout_cardTransform5) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-munich-1-5.png", 0.500, 0.500);
	return this;
}
function PostcardMunich1Layout_cardTransform2(this: IPostcardMunich1Layout_cardTransform2) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-munich-1-2.png", 0.500, 0.500);
	return this;
}
function PostcardMunich1Layout_cardTransform4(this: IPostcardMunich1Layout_cardTransform4) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-munich-1-4.png", 0.500, 0.500);
	return this;
}
function PostcardMunich1Layout_cardTransform1(this: IPostcardMunich1Layout_cardTransform1) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-munich-1-1.png", 0.500, 0.500);
	return this;
}
function PostcardMunich1Layout_cardTransform8(this: IPostcardMunich1Layout_cardTransform8) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-munich-1-8.png", 0.500, 0.500);
	return this;
}
function PostcardMunich1Layout_cardTransform3(this: IPostcardMunich1Layout_cardTransform3) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-munich-1-3.png", 0.500, 0.500);
	return this;
}
function PostcardMunich1Layout_pieces3(this: IPostcardMunich1Layout_pieces3) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-munich-1-3.png", 0.500, 0.500);
	return this;
}
function PostcardMunich1Layout_outlines3(this: IPostcardMunich1Layout_outlines3) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-munich-1-3.png", 0.501, 0.501);
	return this;
}
function PostcardMunich1Layout_pieces6(this: IPostcardMunich1Layout_pieces6) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-munich-1-6.png", 0.406, 0.672);
	return this;
}
function PostcardMunich1Layout_outlines6(this: IPostcardMunich1Layout_outlines6) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-munich-1-6.png", 0.500, 0.500);
	return this;
}
function PostcardMunich1Layout_pieces5(this: IPostcardMunich1Layout_pieces5) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-munich-1-5.png", 0.547, 0.147);
	return this;
}
function PostcardMunich1Layout_outlines5(this: IPostcardMunich1Layout_outlines5) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-munich-1-5.png", 0.500, 0.500);
	return this;
}
function PostcardMunich1Layout_pieces7(this: IPostcardMunich1Layout_pieces7) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-munich-1-7.png", 0.501, 0.502);
	return this;
}
function PostcardMunich1Layout_outlines7(this: IPostcardMunich1Layout_outlines7) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-munich-1-7.png", 0.500, 0.500);
	return this;
}
function PostcardMunich1Layout_pieces1(this: IPostcardMunich1Layout_pieces1) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-munich-1-1.png", 0.500, 0.500);
	return this;
}
function PostcardMunich1Layout_outlines1(this: IPostcardMunich1Layout_outlines1) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-munich-1-1.png", 0.500, 0.501);
	return this;
}
function PostcardMunich1Layout_pieces4(this: IPostcardMunich1Layout_pieces4) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-munich-1-4.png", 0.500, 0.500);
	return this;
}
function PostcardMunich1Layout_outlines4(this: IPostcardMunich1Layout_outlines4) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-munich-1-4.png", 0.501, 0.502);
	return this;
}
function PostcardMunich1Layout_pieces2(this: IPostcardMunich1Layout_pieces2) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-munich-1-2.png", 0.500, 0.500);
	return this;
}
function PostcardMunich1Layout_outlines2(this: IPostcardMunich1Layout_outlines2) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-munich-1-2.png", 0.501, 0.501);
	return this;
}
function PostcardMunich1Layout_pieces8(this: IPostcardMunich1Layout_pieces8) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-munich-1-8.png", 0.502, 0.500);
	return this;
}
function PostcardMunich1Layout_outlines8(this: IPostcardMunich1Layout_outlines8) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-munich-1-8.png", 0.500, 0.500);
	return this;
}
function PostcardMunich1Layout_postcardOverlay(this: IPostcardMunich1Layout_postcardOverlay) {
	if (this.setLayoutTexture) this.setLayoutTexture("postcard-border.png", 0.500, 0.500);
	return this;
}
function PostcardMunich1Layout_postcardMask(this: IPostcardMunich1Layout_postcardMask) {
	return this;
}
interface IPostcardMunich1LayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface IPostcardMunich1LayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface IPostcardMunich1LayoutSprite extends IPostcardMunich1LayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface IPostcardMunich1LayoutText extends IPostcardMunich1LayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface IPostcardMunich1LayoutPolygon extends Array<number> {
}
interface IPostcardMunich1Layout {
	readonly main: IPostcardMunich1Layout_main;
}
interface IPostcardMunich1Layout_main extends IPostcardMunich1LayoutContainer {
	readonly postcard: IPostcardMunich1Layout_postcard;
}
interface IPostcardMunich1Layout_postcard extends IPostcardMunich1LayoutContainer {
	readonly cardTransform: IPostcardMunich1LayoutArray<IPostcardMunich1Layout_cardTransform1|IPostcardMunich1Layout_cardTransform2|IPostcardMunich1Layout_cardTransform3|IPostcardMunich1Layout_cardTransform4|IPostcardMunich1Layout_cardTransform5|IPostcardMunich1Layout_cardTransform6|IPostcardMunich1Layout_cardTransform7|IPostcardMunich1Layout_cardTransform8>;
	readonly items: IPostcardMunich1LayoutArray<IPostcardMunich1Layout_pieces3|IPostcardMunich1Layout_outlines3|IPostcardMunich1Layout_pieces6|IPostcardMunich1Layout_outlines6|IPostcardMunich1Layout_pieces5|IPostcardMunich1Layout_outlines5|IPostcardMunich1Layout_pieces7|IPostcardMunich1Layout_outlines7|IPostcardMunich1Layout_pieces1|IPostcardMunich1Layout_outlines1|IPostcardMunich1Layout_pieces4|IPostcardMunich1Layout_outlines4|IPostcardMunich1Layout_pieces2|IPostcardMunich1Layout_outlines2|IPostcardMunich1Layout_pieces8|IPostcardMunich1Layout_outlines8>;
	readonly background: IPostcardMunich1Layout_background;
	readonly postcardOverlay: IPostcardMunich1Layout_postcardOverlay;
	readonly postcardMask: IPostcardMunich1Layout_postcardMask;
}
interface IPostcardMunich1Layout_background extends IPostcardMunich1LayoutSprite {
}
interface IPostcardMunich1Layout_cardTransform7 extends IPostcardMunich1LayoutSprite {
}
interface IPostcardMunich1Layout_cardTransform6 extends IPostcardMunich1LayoutSprite {
}
interface IPostcardMunich1Layout_cardTransform5 extends IPostcardMunich1LayoutSprite {
}
interface IPostcardMunich1Layout_cardTransform2 extends IPostcardMunich1LayoutSprite {
}
interface IPostcardMunich1Layout_cardTransform4 extends IPostcardMunich1LayoutSprite {
}
interface IPostcardMunich1Layout_cardTransform1 extends IPostcardMunich1LayoutSprite {
}
interface IPostcardMunich1Layout_cardTransform8 extends IPostcardMunich1LayoutSprite {
}
interface IPostcardMunich1Layout_cardTransform3 extends IPostcardMunich1LayoutSprite {
}
interface IPostcardMunich1Layout_pieces3 extends IPostcardMunich1LayoutSprite {
}
interface IPostcardMunich1Layout_outlines3 extends IPostcardMunich1LayoutSprite {
}
interface IPostcardMunich1Layout_pieces6 extends IPostcardMunich1LayoutSprite {
}
interface IPostcardMunich1Layout_outlines6 extends IPostcardMunich1LayoutSprite {
}
interface IPostcardMunich1Layout_pieces5 extends IPostcardMunich1LayoutSprite {
}
interface IPostcardMunich1Layout_outlines5 extends IPostcardMunich1LayoutSprite {
}
interface IPostcardMunich1Layout_pieces7 extends IPostcardMunich1LayoutSprite {
}
interface IPostcardMunich1Layout_outlines7 extends IPostcardMunich1LayoutSprite {
}
interface IPostcardMunich1Layout_pieces1 extends IPostcardMunich1LayoutSprite {
	dependsOn: number;
	outlineGlow: boolean;
}
interface IPostcardMunich1Layout_outlines1 extends IPostcardMunich1LayoutSprite {
}
interface IPostcardMunich1Layout_pieces4 extends IPostcardMunich1LayoutSprite {
	dependsOn: number;
	outlineGlow: boolean;
}
interface IPostcardMunich1Layout_outlines4 extends IPostcardMunich1LayoutSprite {
}
interface IPostcardMunich1Layout_pieces2 extends IPostcardMunich1LayoutSprite {
	dependsOn: number;
	outlineGlow: boolean;
}
interface IPostcardMunich1Layout_outlines2 extends IPostcardMunich1LayoutSprite {
}
interface IPostcardMunich1Layout_pieces8 extends IPostcardMunich1LayoutSprite {
	dependsOn: number;
	outlineGlow: boolean;
}
interface IPostcardMunich1Layout_outlines8 extends IPostcardMunich1LayoutSprite {
}
interface IPostcardMunich1Layout_postcardOverlay extends IPostcardMunich1LayoutSprite {
}
interface IPostcardMunich1Layout_postcardMask extends IPostcardMunich1LayoutPolygon {
}
